// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","513":"c7fe56e0","632":"b990de48","668":"a0f0269d","706":"711ede07","726":"759a3e6d"}[chunkId] + ".chunk.js";
};